// extracted by mini-css-extract-plugin
export default {"root":"AEFlhoVpZB","item":"k8n2YuQEAr","item_stretched":"dEHrnVzbVI"};